module.exports = __webpack_public_path__ + "media/images/sp/plans/button_deco_line-09db4b4978bb83ee4f8bee189a5d6d68.svg";